<div class="close-button" (click)="close()"></div>
<div class="sponsor-dialog">

    <h2 class="dialog-h2">Send the guarantor a link to continue</h2>
    <p class="dialog-text">Click on the button below to send the guarantor a link to continue with the application when it
        is convenient for them.</p>
    <button class="primary-button" matTooltip="Email sent" #emailTooltip="matTooltip" matTooltipPosition="below"
        (mouseenter)="$event.stopImmediatePropagation()" (mouseleave)="$event.stopImmediatePropagation()"
        (click)="sendEmail()">Send email to guarantor</button>
    <button class="secondary-button" matTooltip="Link copied" #tooltip="matTooltip" matTooltipPosition="below"
        (mouseenter)="$event.stopImmediatePropagation()" (mouseleave)="$event.stopImmediatePropagation()"
        (click)="copyToClipboard()">Copy link</button>
</div>